import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';

import { orderedCoreMenteeModulesSelector } from 'features/moduleManagement';
import ErrorLayout from 'components/ErrorLayout';
import MenteeModulesDragDrop from '../MenteeModulesDragDrop';
import MenteeModulesTableHeader from '../MenteeModulesTableHeader';
import MenteeModulesTableRow from '../MenteeModulesTableRow';
import styles from './MenteeModulesTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';

function MenteeModulesTable() {
  const orderedCoreMenteeModules = useSelector(
    orderedCoreMenteeModulesSelector
  );

  if (orderedCoreMenteeModules.length > 0) {
    return (
      <MenteeModulesDragDrop
        orderedCoreMenteeModules={orderedCoreMenteeModules}
      >
        <Table className={styles.table}>
          <MenteeModulesTableHeader />
          <Droppable droppableId="mentee-modules">
            {({ innerRef, droppableProps, placeholder: dropPlaceholder }) => (
              <TableBody
                ref={innerRef}
                {...droppableProps}
              >
                {orderedCoreMenteeModules.map((menteeModule, index) => (
                  <MenteeModulesTableRow
                    menteeModule={menteeModule}
                    key={menteeModule.id}
                    index={index}
                  />
                ))}
                {dropPlaceholder}
              </TableBody>
            )}
          </Droppable>
        </Table>
      </MenteeModulesDragDrop>
    );
  }

  return <ErrorLayout message="This learner does not have any modules." />;
}

export default MenteeModulesTable;
